"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasisTheoryTenants = void 0;

var _common = require("./../common");

var _service = require("./../service");

var _CrudBuilder = require("./../service/CrudBuilder");

const BasisTheoryTenants = new _CrudBuilder.CrudBuilder(class BasisTheoryTenants extends _service.BasisTheoryService {
  retrieve(options) {
    return this.client.get('/', (0, _common.createRequestConfig)(options)).then(_common.dataExtractor);
  }

  update(model, options) {
    return this.client.put('/', model, (0, _common.createRequestConfig)(options)).then(_common.dataExtractor);
  }

  async delete(options) {
    await this.client.delete('/', (0, _common.createRequestConfig)(options));
  }

  retrieveUsageReport(options) {
    return this.client.get('/reports/usage', (0, _common.createRequestConfig)(options)).then(_common.dataExtractor);
  }

  createInvitation(model, options) {
    return this.client.post('/invitations', model, (0, _common.createRequestConfig)(options)).then(_common.dataExtractor);
  }

  resendInvitation(invitationId, options) {
    return this.client.post(`/invitations/${invitationId}/resend`, {}, (0, _common.createRequestConfig)(options)).then(_common.dataExtractor);
  }

  listInvitations(query, options) {
    const url = `/invitations${(0, _common.getQueryParams)(query)}`;
    return this.client.get(url, (0, _common.createRequestConfig)(options)).then(_common.dataExtractor);
  }

  retrieveInvitation(invitationId, options) {
    return this.client.get(`/invitations/${invitationId}`, (0, _common.createRequestConfig)(options)).then(_common.dataExtractor);
  }

  async deleteInvitation(invitationId, options) {
    await this.client.delete(`/invitations/${invitationId}`, (0, _common.createRequestConfig)(options));
  }

  listMembers(query, options) {
    const url = `/members${(0, _common.getQueryParams)(query)}`;
    return this.client.get(url, (0, _common.createRequestConfig)(options)).then(_common.dataExtractor);
  }

  async deleteMember(memberId, options) {
    await this.client.delete(`/members/${memberId}`, (0, _common.createRequestConfig)(options));
  }

}).build();
exports.BasisTheoryTenants = BasisTheoryTenants;